import React from 'react';
import styled from 'styled-components';
import { Icons, ImpContainer, ImpFlex, ImpIcon, ImpText, colors } from '../..';
const CheckboxContainer = styled(ImpContainer) `
  cursor: pointer;
  display: inline-block;
  position: relative;
`;
const Text = styled(ImpText) `
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;
const Container = styled(ImpContainer) `
  cursor: pointer;
  user-select: none;

  ${({ isDisabled }) => isDisabled &&
    `
    cursor: not-allowed;
    opacity: 60%;

    ${CheckboxContainer}, ${Text} {
      pointer-events: none;
    }
  `}
`;
function ImpCheckbox({ color = colors.content.onBackground, isDisabled = false, checked, label, handleClick, }) {
    const Icon = checked ? (React.createElement(ImpIcon, { size: "24px", stroke: color, iconSrc: Icons.checked })) : (React.createElement(ImpIcon, { size: "24px", stroke: color, iconSrc: Icons.unchecked }));
    return (React.createElement(Container, { onClick: isDisabled ? undefined : () => handleClick === null || handleClick === void 0 ? void 0 : handleClick(!checked), tabIndex: isDisabled ? -1 : 0, isDisabled: isDisabled, dataTestId: "checkbox-container" },
        React.createElement(ImpFlex, { direction: "row", align: "center", gap: "s", dataTestId: "checkbox-wrapper" },
            React.createElement(CheckboxContainer, { dataTestId: "icon-container" }, Icon),
            label && (React.createElement(Text, { typography: "body2", dataTestId: "checkbox-label" }, label)))));
}
export default ImpCheckbox;
//# sourceMappingURL=ImpCheckbox.js.map